import { BrowserRouter, Route, Switch } from "react-router-dom";
import Portfolio from "./containers/Portfolio/Portfolio";
import "./App.scss";
import Home from "./containers/Home/Home";
import { NavBar } from "./components/Navbar/NavBar";
// import Contact from './containers/Contact/Contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <NavBar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/portfolio" exact component={Portfolio} />
          {/* <Route path="/contact" exact component={Contact}/> */}
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
